// The BD's own day (TX-US-0028). A session is dated in the calendar of the person reporting, not
// the server's, so the browser says what today is and which timezone it read that in.

const two = (value) => String(value).padStart(2, '0');

// YYYY-MM-DD in the device's local time - not toISOString, which is UTC's date.
export const localDate = (now = new Date()) =>
  `${now.getFullYear()}-${two(now.getMonth() + 1)}-${two(now.getDate())}`;

// The IANA name, recorded on the session for the stories that need it.
export const localTimezone = () => Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC';

// "Wednesday 7 October", for the head of the screen.
export const dayLabel = (now = new Date()) =>
  now.toLocaleDateString(undefined, { weekday: 'long', day: 'numeric', month: 'long' });

// A session's own date, written as the day it was: "7 Oct".
export function sessionDayLabel(isoDate) {
  const [year, month, day] = isoDate.split('-').map(Number);
  return new Date(year, month - 1, day).toLocaleDateString(undefined, {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
  });
}

export const timeLabel = (isoDateTime) =>
  new Date(isoDateTime).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
